<details class="details-root mat-display-1" data-absolute="true">
  <summary class="head">{{head}}</summary>
  <section class="content mat-body-2">
    <ng-content></ng-content>
  </section>
</details>